export enum ActionType {
    TRIGGER_ACTION_CALENDAR_PRINT = 'TRIGGER_ACTION_CALENDAR_PRINT',
    RESET_ACTION_CALENDAR_PRINT  = 'RESET_ACTION_CALENDAR_PRINT',

    TRIGGER_ACTION_FLOORPLAN_PRINT = 'TRIGGER_ACTION_FLOORPLAN_PRINT',
    RESET_ACTION_FLOORPLAN_PRINT  = 'RESET_ACTION_FLOORPLAN_PRINT',


    TRIGGER_ACTION_LIST_PRINT = 'TRIGGER_ACTION_LIST_PRINT',
    RESET_ACTION_LIST_PRINT  = 'RESET_ACTION_LIST_PRINT',

    TRIGGER_ACTION_HALFBOARD_LIST_PRINT = 'TRIGGER_ACTION_HALFBOARD_LIST_PRINT',
    RESET_ACTION_HALFBOARD_LIST_PRINT  = 'RESET_ACTION_HALFBOARD_LIST_PRINT',

    TRIGGER_ACTION_DAILY_LIST_PRINT = 'TRIGGER_ACTION_DAILY_LIST_PRINT',
    RESET_ACTION_DAILY_LIST_PRINT  = 'RESET_ACTION_DAILY_LIST_PRINT',

    TRIGGER_SEARCH_BAR = 'TRIGGER_SEARCH_BAR',
    RESET_SEARCH_BAR = 'RESET_SEARCH_BAR',

    TRIGGER_RESERVATION_EXPORT = 'TRIGGER_RESERVATION_EXPORT',
    RESET_RESERVATION_EXPORT = 'RESET_RESERVATION_EXPORT',
}

const initialState = {
    actionTriggered: false,
    floorplanPrintTriggered: false,
    listPrintTriggered: false,
    halfboardListPrintTriggered: false,
    dailyListPrintTriggered: false,
    searchBarTriggered: false,
    reservationExportTriggered: false
};

export const triggerActionCalendarPrint = () => ({
    type: ActionType.TRIGGER_ACTION_CALENDAR_PRINT,
});

export const resetActionCalendarPrint = () => ({
    type: ActionType.RESET_ACTION_CALENDAR_PRINT,
});

export const triggerActionFloorplanPrint = () => ({
    type: ActionType.TRIGGER_ACTION_FLOORPLAN_PRINT,
});

export const resetActionFloorplanPrint = () => ({
    type: ActionType.RESET_ACTION_FLOORPLAN_PRINT,
});

export const triggerActionListPrint = () => ({
    type: ActionType.TRIGGER_ACTION_LIST_PRINT,
});

export const triggerActionHalfboardListPrint = () => ({
    type: ActionType.TRIGGER_ACTION_HALFBOARD_LIST_PRINT,
});

export const triggerActionDailyListPrint = () => ({
    type: ActionType.TRIGGER_ACTION_DAILY_LIST_PRINT,
});

export const resetActionListPrint = () => ({
    type: ActionType.RESET_ACTION_LIST_PRINT,
});

export const triggerSearchBar = () => ({
    type: ActionType.TRIGGER_SEARCH_BAR,
});

export const resetSearchBar = () => ({
    type: ActionType.RESET_SEARCH_BAR,
});

export const resetActionHalfboardListPrint = () => ({
    type: ActionType.RESET_ACTION_HALFBOARD_LIST_PRINT,
});

export const resetActionDailyListPrint = () => ({
    type: ActionType.RESET_ACTION_DAILY_LIST_PRINT,
});

export const triggerReservationExport = () => ({
    type: ActionType.TRIGGER_RESERVATION_EXPORT
});

export const resetReservationExport = () => ({
    type: ActionType.RESET_RESERVATION_EXPORT
});


// We need some general way of dispatching actions between components
export const actionReducer = (state = initialState, action: { type: ActionType }) => {
    switch (action.type) {
        case ActionType.TRIGGER_ACTION_CALENDAR_PRINT:
            return {
                ...state,
                actionTriggered: true,
            };
        case ActionType.RESET_ACTION_CALENDAR_PRINT:
            return {
                ...state,
                actionTriggered: false,
            };

        case ActionType.TRIGGER_ACTION_LIST_PRINT:
            return { ...state, listPrintTriggered: true };
        case ActionType.RESET_ACTION_LIST_PRINT:
            return { ...state, listPrintTriggered: false };

        case ActionType.TRIGGER_ACTION_FLOORPLAN_PRINT:
            return { ...state, floorplanPrintTriggered: true };
        case ActionType.RESET_ACTION_FLOORPLAN_PRINT:
            return { ...state, floorplanPrintTriggered: false };

        case ActionType.TRIGGER_SEARCH_BAR:
            return { ...state, searchBarTriggered: !state.searchBarTriggered };

        case ActionType.RESET_SEARCH_BAR:
            return { ...state, searchBarTriggered: false };

        case ActionType.TRIGGER_ACTION_HALFBOARD_LIST_PRINT:
            return { ...state, halfboardListPrintTriggered: true };
        case ActionType.RESET_ACTION_HALFBOARD_LIST_PRINT:
            return { ...state, halfboardListPrintTriggered: false };

        case ActionType.TRIGGER_ACTION_DAILY_LIST_PRINT:
            return { ...state, dailyListPrintTriggered: true };
        case ActionType.RESET_ACTION_DAILY_LIST_PRINT:
            return { ...state, dailyListPrintTriggered: false };

        case ActionType.TRIGGER_RESERVATION_EXPORT:
            return { ...state, reservationExportTriggered: true };
        case ActionType.RESET_RESERVATION_EXPORT:
            return { ...state, reservationExportTriggered: false };
        default:
            return state;
    }
}
